import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static values = { 
    todoId: Number,
    completeUrl: String,
    incompleteUrl: String
  }

  async toggleComplete() {
    const todoId = this.todoIdValue
    const isCompleted = this.element.classList.contains('bg-green-500')
    
    try {
      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
      
      // Bestimme die richtige URL basierend auf dem aktuellen Status
      const url = isCompleted ? this.incompleteUrlValue : this.completeUrlValue
      
      const response = await fetch(url, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken,
          'Accept': 'text/vnd.turbo-stream.html'
        },
        body: JSON.stringify({
          turbo_stream: true,
          todo_id: todoId
        })
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      // Turbo Stream Response mit Turbo API verarbeiten
      const turboStream = await response.text()
      
      if (turboStream) {
        // Verwende Turbo Stream API um die Response zu verarbeiten
        Turbo.renderStreamMessage(turboStream)
      }
      
    } catch (error) {
      console.error('Error toggling todo completion:', error)
      // Hier könnte man eine Fehlermeldung anzeigen
    }
  }
}
